import { useQueryClient } from '@tanstack/react-query';
import { useApplicationLocalStorage } from '../../application-hook';
import { ProfessionalApplicationParameters } from '@platform/client/schemas';
import { useState } from 'react';
import { ApplicationPageProps } from '../../Application';
import { Application } from '@platform/client';
import { RejoinCohortDetails, SignUpCohortDetails } from '../../program/shared/CohortDetails';
import { ErrorBox } from '@platform/components';
import { REVIEW_MODE_STORAGE_KEY, ReviewModeStorage } from '../../../dashboard/home/RejoinPanel';

export const PhilipsConfirmAndSubmit = (props: ApplicationPageProps) => {
  const [failed, setFailed] = useState(false);
  const { getApplicationData, getApplicationDataByKey } =
    useApplicationLocalStorage<ProfessionalApplicationParameters>(props.dataKey);
  const rejoinCohort = getApplicationDataByKey('cohortId');

  // clear flag to allow confirmation page to be re-visited.
  const { clearApplicationData: clearReviewModeData } =
    useApplicationLocalStorage<ReviewModeStorage>(REVIEW_MODE_STORAGE_KEY);
  clearReviewModeData();

  const submitPhilipsMutation = Application.useSubmitPhilipsApplication();
  const queryClient = useQueryClient();
  const submit = () => {
    submitPhilipsMutation.mutate(
      {
        data: {
          cohortId: rejoinCohort ?? null,
          ...getApplicationData(),
        },
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries({
            queryKey: Application.getGetProfessionalApplicationStatusQueryKey(),
          });
        },
        onError: () => {
          setFailed(true);
        },
      },
    );
  };

  return (
    <>
      {rejoinCohort ?
        <RejoinCohortDetails
          cohortId={parseInt(rejoinCohort)}
          onBack={props.onBack}
          onSubmit={submit}
          isSubmitting={submitPhilipsMutation.isPending || submitPhilipsMutation.isSuccess}
        />
      : <SignUpCohortDetails
          onBack={props.onBack}
          onSubmit={submit}
          isSubmitting={submitPhilipsMutation.isPending || submitPhilipsMutation.isSuccess}
        />
      }
      {failed && (
        <ErrorBox showAlertTriangle={true}>
          There was an error submitting your application. Please try again later.
        </ErrorBox>
      )}
    </>
  );
};
